import { OralExamSessionPhase } from '@/common/api/models/oralExamSessionPhase';
import { isCohortExamSurface } from '@/common/utils/oralExam/runConduct';

import type { ExamLeaveGuardReport } from './ExamLeaveGuard';

export type ExamLeaveGuardBookingRun = {
  runState: {
    state?: string;
    mode?: string | null;
  };
};

export type DeriveExamLeaveGuardParams = {
  capacity: number;
  sessionPhase: OralExamSessionPhase | null | undefined;
  bookingRuns: ExamLeaveGuardBookingRun[];
  minSupervisors?: number | null;
};

export function resolveIsCohortExamSurface(
  capacity: number,
  bookingRuns: ExamLeaveGuardBookingRun[],
): boolean {
  if (bookingRuns.length === 0) {
    return capacity >= 2;
  }
  const runWithMode = bookingRuns.find((run) => run.runState.mode);
  if (!runWithMode) {
    return false;
  }
  return isCohortExamSurface(runWithMode.runState);
}

export function deriveExamLeaveGuard(
  params: DeriveExamLeaveGuardParams,
): Pick<ExamLeaveGuardReport, 'active' | 'kind' | 'minSupervisors'> {
  const {
    capacity, sessionPhase, bookingRuns, minSupervisors,
  } = params;
  const isCohort = resolveIsCohortExamSurface(capacity, bookingRuns);
  const hasInProgressRun = bookingRuns.some((run) => run.runState.state === 'in_progress');
  const groupExamRunning = isCohort
    && sessionPhase === OralExamSessionPhase.in_exam
    && hasInProgressRun;
  const oneToOneExamRunning = !isCohort && hasInProgressRun;

  return {
    active: groupExamRunning || oneToOneExamRunning,
    kind: isCohort ? 'group' : 'one_to_one',
    minSupervisors: minSupervisors ?? 1,
  };
}
